import { useCallback, useEffect, useState } from 'react';

import { COACH_ANIMATION_STATES } from 'bundles/unified-home-common/constants';

type CoachAnimationState = (typeof COACH_ANIMATION_STATES)[keyof typeof COACH_ANIMATION_STATES];

const useCoachWinkingAnimation = () => {
  const [coachAnimationState, setCoachAnimationState] = useState<CoachAnimationState>(COACH_ANIMATION_STATES.DEFAULT);

  const handleCoachStateChange = useCallback<(...args: $TSFixMe[]) => $TSFixMe>((state: CoachAnimationState) => {
    setCoachAnimationState(state);
  }, []);

  const triggerWink = useCallback<() => $TSFixMe>(() => {
    setCoachAnimationState(COACH_ANIMATION_STATES.WINK);

    setTimeout(() => {
      setCoachAnimationState(COACH_ANIMATION_STATES.DEFAULT);
    }, 400);
  }, []);

  useEffect(() => {
    // Trigger wink every 5 seconds
    const winkInterval = setInterval(triggerWink, 5000);
    return () => clearInterval(winkInterval);
  }, [triggerWink]);

  return {
    coachAnimationState,
    handleCoachStateChange,
  };
};

export default useCoachWinkingAnimation;
